import pakTani from 'assets/icons/Pak-Tani.png'
import { P } from 'components'
import ProfilePic from 'components/PMBProfilePic'
import BreadCrumbs from 'components/breadcrumbs'
import LoadingV2 from 'components/LoadingV2'
import PMBInputNumber from 'components/PMBInputNumber'
import PMBTotalFooter from 'components/PMBTotalFooter'
import { useAdjustBySellerMutation } from 'features/public-views/order/requestTransactionApiSlice'
import { capitalizeEveryWord } from 'helpers'
import { useSnackbar } from 'notistack'
import { useCallback, useEffect, useRef, useState } from 'react'
import { ArrowLeft, ChevronDown, ChevronUp, Info } from 'react-feather'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  Button,
  Card,
  CardBody,
  Col,
  Collapse,
  Container,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from 'reactstrap'
import colors from 'Theme/colors'

import PMBBadge from 'components/PMBBadge'
import PMBSearchInputGroup from 'components/PMBSearchInputGroup'
import PMBSelect from 'components/PMBSelect'
import moment from 'moment-timezone'
import { formatInputNumber } from 'utility/Utils'
import { newFormatThousandSeparator } from 'utils/formatNumber'
import { URL_DETAIL_TRANSACTION } from 'utils/pathUrl'
import FormatProcessor from 'utils/FormatProcessor'
import {
  useCreateAdjustmentMutation,
  useCreateAdjustmentSetDraftMutation,
  useFetchAdjustmentGetDraftMutation,
  useFetchTransactionAdjustmentQuery,
} from '../dashboard/dashboardApiSlice'
import { useGlobalScanner } from 'hooks/useGlobalScanner'

const OrderAdjustment = () => {
  const intl = useIntl()
  const navigate = useNavigate()
  const location = useLocation()
  const { profile } = useSelector((s) => s.dashboard)

  const { enqueueSnackbar } = useSnackbar()

  const [createAdjustment, { isLoading: isSubmitting }] =
    useCreateAdjustmentMutation()
  const [adjustBySeller, { isLoading: isLoadingRelease }] =
    useAdjustBySellerMutation()
  const [fetchAdjustmentGetDraft, { isLoading: isLoadingGetDraft }] =
    useFetchAdjustmentGetDraftMutation()
  const [fetchAdjustmentSetDraft, { isLoading: isLoadingSetDraft }] =
    useCreateAdjustmentSetDraftMutation()
  const [screenWidth, setScreenWidth] = useState(window.innerWidth)
  const [showAll, setShowAll] = useState(false)
  const [indexAdjustment, setIndexAdjustment] = useState(0)
  const [showPreview, setShowPreview] = useState(false)
  const isMobile = screenWidth <= 768
  const [searchQuery, setSearchQuery] = useState('')
  const itemRefs = useRef({})
  const searchTimeoutRef = useRef(null)
  const containerRef = useRef(null)
  const autoSaveTimeoutRef = useRef(null)
  const isInitializedRef = useRef(false)
  const [collapsedItems, setCollapsedItems] = useState({})
  const [isLeftCardCollapsed, setIsLeftCardCollapsed] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth)
    }

    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  // AUTO EXPAND LEFT CARD WHEN MOBILE
  useEffect(() => {
    if (!isMobile && isLeftCardCollapsed) {
      setIsLeftCardCollapsed(false)
    }
  }, [isMobile, isLeftCardCollapsed])

  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current)
      }
    }
  }, [])

  // GET STATE FROM NAVIGATION (with sessionStorage fallback for page refresh)
  const SESSION_STORAGE_KEY = 'order-adjustment-state'

  const getPersistedState = () => {
    if (location.state) {
      // Save to sessionStorage whenever we have fresh navigation state
      try {
        sessionStorage.setItem(
          SESSION_STORAGE_KEY,
          JSON.stringify(location.state),
        )
      } catch (e) {
        console.error('Error saving state to sessionStorage:', e)
      }
      return location.state
    }

    // Fallback: restore from sessionStorage on page refresh
    try {
      const saved = sessionStorage.getItem(SESSION_STORAGE_KEY)
      if (saved) {
        return JSON.parse(saved)
      }
    } catch (e) {
      console.error('Error reading state from sessionStorage:', e)
    }

    return {}
  }

  const persistedState = getPersistedState()

  const {
    escrowpaymentId,
    ownerPhoneNumber,
    TransactionType,
    imageUser,
    sellerName,
    isZeroPrice,
    isAdjustBySeller,
    adjustFufilmentData,
  } = persistedState

  // TRANSACTION ADJUSTMENT
  const { data, isLoading, refetch } = useFetchTransactionAdjustmentQuery(
    {
      escrowpaymentId,
      customerCode: ownerPhoneNumber,
    },
    { skip: !escrowpaymentId || !ownerPhoneNumber },
  )

  // OPTIONS FOR SELECT FIELDS
  const editTypeOptions = [
    { label: 'Pilih Tipe Penyesuaian', value: '' },
    { label: 'Penyesuaian', value: 'ADJUSTMENT' },
    { label: 'Return', value: 'RETURN' },
  ]

  const causeOfChangeOptions = [
    { label: 'Pilih Penyebab', value: '' },
    { label: 'Weight Change / Loss', value: 'Weight Change / Loss' },
    { label: 'Quantity Mismatch', value: 'Quantity Mismatch' },
    { label: 'Quality / Grading Issue', value: 'Quality / Grading Issue' },
    { label: 'Item Mismatch', value: 'Item Mismatch' },
    { label: 'Defect / Reject', value: 'Defect / Reject' },
  ]

  // STATE FOR ADJUSTMENT ITEMS
  const [adjustmentItems, setAdjustmentItems] = useState([])

  const scrollToItem = (itemId) => {
    const element = itemRefs.current[itemId]

    if (element) {
      try {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        })

        setTimeout(() => {
          const rect = element.getBoundingClientRect()
          const absoluteTop = rect.top + window.pageYOffset
          const middle = absoluteTop - window.innerHeight / 2
          window.scrollTo({
            top: middle,
            behavior: 'smooth',
          })
        }, 100)

        return true
      } catch (error) {
        console.error('✗ Scroll error:', error)
        return false
      }
    } else {
      const fallbackElement = document.querySelector(
        `[data-item-id="${itemId}"]`,
      )
      if (fallbackElement) {
        fallbackElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        })
        return true
      }
      return false
    }
  }

  const handleScan = useCallback(
    (value, scanEvent) => {
      if (!value) return

      // Smart extraction for better local matching
      const parsed = FormatProcessor.parse(value)
      const namePart = parsed?.productDescription || value.match(/(?:P|PD)[=:][^|]+/i)?.[0]?.split(/[=:]/)[1]
      const idMatch = value.match(/(?:ID|SER):([^|]+)/i)
      const extractedId = parsed?.serial || (idMatch ? idMatch[1] : null)

      const matchedIndex = adjustmentItems.findIndex((item) => {
        const query = value.toLowerCase()
        const nameQuery = namePart ? namePart.toLowerCase() : null

        return (
          item?.ownerCode?.toLowerCase().includes(query) ||
          item?.lotCode?.toLowerCase().includes(query) ||
          item?.orderitemId?.toString() === value ||
          (nameQuery && item?.nameItem?.toLowerCase().includes(nameQuery)) ||
          (extractedId && (item?.id?.toString() === extractedId || item?.orderitemId?.toString() === extractedId))
        )
      })

      if (matchedIndex !== -1) {
        // INTERCEPT: Tell global scanner this scan is handled
        if (scanEvent && scanEvent.preventDefault) {
          scanEvent.preventDefault()
        }

        if (showAll) {
          const itemId = adjustmentItems[matchedIndex].orderitemId
          scrollToItem(itemId)
        } else {
          setIndexAdjustment(matchedIndex)
        }
        enqueueSnackbar(`Item ditemukan: ${adjustmentItems[matchedIndex].nameItem}`, {
          variant: 'success',
        })
      } else {
        enqueueSnackbar('Item tidak ditemukan', { variant: 'warning' })
      }
    },
    [adjustmentItems, showAll, enqueueSnackbar, scrollToItem],
  )

  // Removed redundant local useGlobalScanner. 
  // Global scannerHandlers.js now manages the search bar population.

  // HELPER FUNCTIONS FOR API DRAFT
  const loadDraftFromAPI = async () => {
    try {
      const response = await fetchAdjustmentGetDraft({
        escrowpaymentId: escrowpaymentId,
      }).unwrap()

      if (response?.length) {
        return response
      }
    } catch (error) {
      console.error('Error loading draft from API:', error)
    }
    return null
  }

  const saveDraftToAPI = async (isInitial = false, items) => {
    try {
      await fetchAdjustmentSetDraft({
        escrowpaymentId: escrowpaymentId,
        data: items.map((item) => ({
          orderitemId: item.orderitemId,
          newAmount: item.newAmount,
          newSinglePrice: item.newSinglePrice,
          editType: item.editType,
          causeOfChange: item.causeOfChange,
          reason: item.reason,
          isChecked: item.isChecked,
          checkUserId: item?.userId
            ? item?.userId
            : item.isChecked
              ? +profile?.userId
              : null,
          checkTime: item?.checkTime
            ? item?.checkTime
            : item.isChecked
              ? moment().toISOString()
              : null,
        })),
      }).unwrap()
      if (isInitial) {
        enqueueSnackbar('Draft berhasil disimpan', { variant: 'success' })
      }
    } catch (error) {
      console.error('Error saving draft to API:', error)
    }
  }

  // const clearDraftFromAPI = async () => {
  //   try {
  //     await fetchAdjustmentSetDraft({
  //       escrowpaymentId,
  //       adjustmentitems: [],
  //     }).unwrap()
  //   } catch (error) {
  //     console.error('Error clearing draft from API:', error)
  //   }
  // }

  useEffect(() => {
    const initializeAdjustmentItems = async () => {
      if (!data?.orderItems?.length) return

      const draftData = await loadDraftFromAPI()

      const newItems = data.orderItems.map((item, index) => {
        const draftItem = draftData?.find(
          (d) => d.orderitemId === item.id || d.orderitemId === item.orderitemId,
        )
        const adjItem = data?.adjustment?.adjustmentitems?.find(
          (a) => a?.orderitemId === item?.id,
        )

        const isChecked = draftItem ? draftItem.isChecked || false : false
        const editType = draftItem?.editType || editTypeOptions[0]?.value
        const causeOfChange =
          draftItem?.causeOfChange || causeOfChangeOptions[0]?.value
        const reason = draftItem?.reason || ''
        const checkUserId = draftItem?.checkUserId || null
        const checkTime = draftItem?.checkTime || null

        const newAmount = draftItem
          ? draftItem.newAmount
          : adjustFufilmentData?.[index]?.newAmount >= 0
            ? adjustFufilmentData?.[index]?.newAmount
            : adjItem?.newAmount ?? item.amount

        const newSinglePrice = draftItem
          ? draftItem.newSinglePrice
          : adjustFufilmentData?.[index]?.price ?? adjItem?.newPrice ?? item.price

        const ownerCode =
          item?.inventories?.length > 0
            ? item.inventories
              .map((inv) => inv?.ownerCode)
              .filter(Boolean)
              .join(', ')
            : '-'

        const lotCode =
          item?.inventories?.length > 0
            ? item.inventories
              .map((inv) => inv?.lotCode)
              .filter(Boolean)
              .join(', ')
            : '-'

        const bundle =
          item?.inventories?.length > 0
            ? item.inventories
              .map((inv) => inv?.bundle)
              .filter(Boolean)
              .join(', ')
            : item?.bundle ?? '-'

        return {
          orderitemId: item.id,
          nameItem: item.nameItem,
          amount: item.amount,
          unit: item.unit,
          price: item.price,
          totalPrice: item.totalPrice,
          newAmount,
          newSinglePrice,
          isChecked,
          editType,
          causeOfChange,
          reason,
          checkUserId,
          checkTime,
          ownerCode,
          lotCode,
          bundle,
        }
      })

      setAdjustmentItems(newItems)

      // Save initial data if no draft existed
      if (!draftData || draftData.length === 0) {
        await saveDraftToAPI(false, newItems)
      }
    }

    if (data && escrowpaymentId && ownerPhoneNumber) {
      initializeAdjustmentItems().then(() => {
        // Mark as initialized so auto-save can start tracking changes
        isInitializedRef.current = true
      })
    }
  }, [data, escrowpaymentId, ownerPhoneNumber])

  // AUTO-SAVE DRAFT: debounced save to API whenever adjustmentItems change
  useEffect(() => {
    // Skip auto-save if not yet initialized (prevents saving during initial load)
    if (!isInitializedRef.current) return
    if (!adjustmentItems.length) return
    if (!escrowpaymentId) return

    if (autoSaveTimeoutRef.current) {
      clearTimeout(autoSaveTimeoutRef.current)
    }

    autoSaveTimeoutRef.current = setTimeout(() => {
      saveDraftToAPI(false, adjustmentItems)
    }, 2000)

    return () => {
      if (autoSaveTimeoutRef.current) {
        clearTimeout(autoSaveTimeoutRef.current)
      }
    }
  }, [adjustmentItems])

  // HANDLE CHANGE NUMBER
  const handleAmountChange = useCallback((index, value, type) => {
    const replaceValue = value.replace(/[^\d,]/g, '')

    const [integerPart, decimalPart] = replaceValue.split(',')

    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.')

    const formattedValue = decimalPart
      ? `${formattedInteger},${decimalPart}`
      : formattedInteger

    const numericValue =
      parseFloat(formattedValue.replace(/\./g, '').replace(',', '.')) || 0

    setAdjustmentItems((prev) => {
      const updatedItems = prev.map((adjItem, idx) => {
        if (idx === index) {
          if (type === 'amount') {
            return {
              ...adjItem,
              newAmount: numericValue,
            }
          } else if (type === 'price') {
            return {
              ...adjItem,
              newSinglePrice: numericValue,
            }
          }
        }
        return adjItem
      })
      return updatedItems
    })
  }, [])

  const urlBackBreadcrumb = `${window.location.origin}${URL_DETAIL_TRANSACTION}/${escrowpaymentId}?type=${TransactionType}`
  const urlNavigate = `${URL_DETAIL_TRANSACTION}/${escrowpaymentId}?type=${TransactionType}`

  const getAdjustmentErrorMessage = (error) => {
    if (typeof error === 'string') {
      return error
    }

    return (
      error?.data?.message ||
      error?.data?.meta?.message ||
      error?.message ||
      'Penyesuaian gagal disimpan!'
    )
  }

  const handleSubmitAdjustment = async () => {
    const payload = {
      escrowpaymentId,
      customerCode: ownerPhoneNumber,
      adjustmentitems: adjustmentItems.map((item) => ({
        orderitemId: item.orderitemId,
        newAmount: item.newAmount,
        newSinglePrice: item.newSinglePrice,
        editType: item.editType,
        causeOfChange: item.causeOfChange,
        reason: item.reason,
        checkUserId: item?.checkUserId || null,
        checkTime: item?.checkTime || null,
      })),
    }

    try {
      let response
      if (isAdjustBySeller) {
        response = await adjustBySeller(payload).unwrap()
      } else {
        response = await createAdjustment(payload).unwrap()
      }
      enqueueSnackbar('Penyesuaian berhasil disimpan!', { variant: 'success' })

      if (response?.id) {
        navigate(urlNavigate)
      }
    } catch (error) {
      enqueueSnackbar(getAdjustmentErrorMessage(error), {
        variant: 'error',
      })
    }
  }

  const unitSummary = data?.orderItems?.reduce((acc, item, index) => {
    const unit = item?.unit?.toLowerCase()
    if (!unit) return acc
    if (!acc[unit]) {
      acc[unit] = { unit, inventoryCount: 0, totalAmount: 0, newTotalAmount: 0 }
    }
    acc[unit].inventoryCount += 1
    acc[unit].totalAmount += Number(item?.amount ?? 0)
    acc[unit].newTotalAmount += Number(adjustmentItems?.[index]?.newAmount)
    return acc
  }, {})

  const unitSummaryArray = Object.values(unitSummary || {})

  const checkCanAdjust = (items) => {
    const hasDifference = items.some(
      (item) =>
        item.amount !== item.newAmount || item.price !== item.newSinglePrice,
    )

    if (hasDifference) {
      setShowPreview(true)
    } else {
      enqueueSnackbar(
        'Tidak ada penyesuaian, silakan lakukan penyesuaian terlebih dahulu',
        { variant: 'error' },
      )
    }
  }

  // HANDLE FIELD CHANGE FOR NEW FIELDS
  const handleFieldChange = useCallback(
    (index, field, value) => {
      setAdjustmentItems((prev) => {
        const updatedItems = prev.map((adjItem, idx) => {
          if (idx === index) {
            if (field === 'isChecked') {
              return {
                ...adjItem,
                [field]: value,
                checkUserId: value === true ? +profile?.userId : null,
                checkTime: value === true ? moment().toISOString() : null,
              }
            } else {
              return {
                ...adjItem,
                [field]: value,
              }
            }
          }
          return adjItem
        })

        return updatedItems
      })
    },
    [profile?.userId],
  )

  const isAllChecked =
    adjustmentItems?.length > 0 &&
    adjustmentItems.every((item) => item.isChecked)

  const handleCheckAll = useCallback(() => {
    const newCheckedState = !isAllChecked
    const currentTime = moment().toISOString()
    const currentUserId = +profile?.userId

    setAdjustmentItems((prev) =>
      prev.map((adjItem) => ({
        ...adjItem,
        isChecked: newCheckedState,
        checkUserId: newCheckedState ? currentUserId : null,
        checkTime: newCheckedState ? currentTime : null,
      })),
    )
  }, [isAllChecked, profile?.userId])

  const isDisabledProcess = adjustmentItems.some((item) => !item.isChecked)

  const countChecked = adjustmentItems?.filter((item) => item.isChecked).length

  function calculateTotalByType(items, type) {
    return items?.reduce((acc, item) => {
      const isMatch = item.editType?.toLowerCase() === type.toLowerCase()
      const hasDifference =
        item.amount !== item.newAmount || item.price !== item.newSinglePrice

      if (isMatch && hasDifference) {
        return acc + (item.newAmount || 0)
      }

      return acc
    }, 0)
  }

  if (isLoading || isLoadingGetDraft) {
    return <LoadingV2 />
  }

  const handleGoToUnchecked = () => {
    const nextUncheckedIndex = adjustmentItems.findIndex(
      (item, idx) => idx > indexAdjustment && !item.isChecked,
    )

    if (nextUncheckedIndex !== -1) {
      if (showAll) {
        const itemId = adjustmentItems[nextUncheckedIndex].orderitemId
        setTimeout(() => {
          scrollToItem(itemId)
        }, 100)
      } else {
        setIndexAdjustment(nextUncheckedIndex)
        enqueueSnackbar(
          `Menampilkan item: ${adjustmentItems[nextUncheckedIndex].nameItem}`,
          { variant: 'info' },
        )
      }
    } else {
      const firstUncheckedIndex = adjustmentItems.findIndex(
        (item) => !item.isChecked,
      )
      if (firstUncheckedIndex !== -1) {
        setIndexAdjustment(firstUncheckedIndex)
        enqueueSnackbar(
          `Menampilkan item: ${adjustmentItems[firstUncheckedIndex].nameItem}`,
          { variant: 'info' },
        )
      } else {
        enqueueSnackbar('Semua item sudah dicek', { variant: 'success' })
      }
    }
  }

  const getMatchingIndices = (query) => {
    if (!query) return []

    return adjustmentItems
      .map((item, index) => {
        const combinedAmountUnit =
          `${item?.newAmount ?? ''}${item?.unit ?? ''}`.toLowerCase()
        const combinedAmountUnitWithSpace =
          `${item?.newAmount ?? ''} ${item?.unit ?? ''}`.toLowerCase()

        const matches =
          item?.nameItem?.toLowerCase().includes(query.toLowerCase()) ||
          item?.ownerCode?.toLowerCase().includes(query.toLowerCase()) ||
          item?.lotCode?.toLowerCase().includes(query.toLowerCase()) ||
          item?.newAmount?.toString().includes(query) ||
          item?.unit?.toLowerCase().includes(query.toLowerCase()) ||
          combinedAmountUnit.includes(query.toLowerCase()) ||
          combinedAmountUnitWithSpace.includes(query.toLowerCase())

        return matches ? index : null
      })
      .filter((index) => index !== null)
  }

  const handleNextSameValueSearch = () => {
    if (!searchQuery) {
      if (indexAdjustment === adjustmentItems?.length - 1) {
        return
      }
      setIndexAdjustment((prevState) => prevState + 1)
      return
    }

    const matchedIndices = getMatchingIndices(searchQuery)

    if (matchedIndices.length === 0) {
      enqueueSnackbar('Tidak ada item yang cocok dengan pencarian', {
        variant: 'warning',
      })
      return
    }

    if (matchedIndices.length === 1) {
      enqueueSnackbar('Hanya ada 1 item yang cocok', {
        variant: 'info',
      })
      return
    }

    const currentIndex = indexAdjustment
    const nextMatchIndex = matchedIndices.find((idx) => idx > currentIndex)

    let targetIndex
    let searchPosition

    if (nextMatchIndex !== undefined) {
      targetIndex = nextMatchIndex
      searchPosition = matchedIndices.indexOf(nextMatchIndex)
    } else {
      targetIndex = matchedIndices[0]
      searchPosition = 0
    }

    const targetItem = adjustmentItems[targetIndex]

    if (showAll) {
      setTimeout(() => {
        scrollToItem(targetItem.orderitemId)
      }, 100)
    } else {
      setIndexAdjustment(targetIndex)
    }

    enqueueSnackbar(
      `Menampilkan hasil ${searchPosition + 1} dari ${matchedIndices.length}: ${targetItem.nameItem}`,
      { variant: 'info' },
    )
  }

  const handlePrevSameValueSearch = () => {
    if (!searchQuery) {
      if (indexAdjustment < 1) {
        return
      }
      setIndexAdjustment((prevState) => prevState - 1)
      return
    }

    const matchedIndices = getMatchingIndices(searchQuery)

    if (matchedIndices.length === 0) {
      enqueueSnackbar('Tidak ada item yang cocok dengan pencarian', {
        variant: 'warning',
      })
      return
    }

    if (matchedIndices.length === 1) {
      enqueueSnackbar('Hanya ada 1 item yang cocok', {
        variant: 'info',
      })
      return
    }

    const currentIndex = indexAdjustment
    const reversedMatches = [...matchedIndices].reverse()
    const prevMatchIndex = reversedMatches.find((idx) => idx < currentIndex)

    let targetIndex
    let searchPosition

    if (prevMatchIndex !== undefined) {
      targetIndex = prevMatchIndex
      searchPosition = matchedIndices.indexOf(prevMatchIndex)
    } else {
      targetIndex = matchedIndices[matchedIndices.length - 1]
      searchPosition = matchedIndices.length - 1
    }

    const targetItem = adjustmentItems[targetIndex]

    if (showAll) {
      setTimeout(() => {
        scrollToItem(targetItem.orderitemId)
      }, 100)
    } else {
      setIndexAdjustment(targetIndex)
    }

    enqueueSnackbar(
      `Menampilkan hasil ${searchPosition + 1} dari ${matchedIndices.length}: ${targetItem.nameItem}`,
      { variant: 'info' },
    )
  }

  const performSearch = (value) => {
    if (!value) {
      return { found: null }
    }

    const matchedIndices = getMatchingIndices(value)

    if (matchedIndices.length > 0) {
      const firstMatchIndex = matchedIndices[0]
      const matchedItem = adjustmentItems[firstMatchIndex]

      if (showAll) {
        const itemId = matchedItem.orderitemId
        setTimeout(() => {
          scrollToItem(itemId)
        }, 100)
      } else {
        setIndexAdjustment(firstMatchIndex)
      }

      return {
        found: true,
        item: matchedItem,
        totalMatches: matchedIndices.length,
      }
    }

    return { found: false }
  }

  const handleSearch = (value) => {
    setSearchQuery(value)

    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current)
    }

    if (!value) {
      return { found: null }
    }

    searchTimeoutRef.current = setTimeout(() => {
      const result = performSearch(value)

      if (result.found === true) {
        enqueueSnackbar(
          `Ditemukan ${result.totalMatches} hasil untuk: ${value}`,
          { variant: 'info' },
        )
      } else if (result.found === false) {
        enqueueSnackbar('Item tidak ditemukan', { variant: 'warning' })
      }
    }, 500)
  }

  const handleSearchSubmit = () => {
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current)
    }

    if (!searchQuery) return

    const matchedIndices = getMatchingIndices(searchQuery)

    if (matchedIndices.length === 0) {
      enqueueSnackbar('Item tidak ditemukan', { variant: 'warning' })
      return
    }

    if (matchedIndices.length === 1) {
      const targetItem = adjustmentItems[matchedIndices[0]]
      if (showAll) {
        setTimeout(() => {
          scrollToItem(targetItem.orderitemId)
        }, 100)
      } else {
        setIndexAdjustment(matchedIndices[0])
      }
      enqueueSnackbar(`Menampilkan: ${targetItem.nameItem}`, {
        variant: 'info',
      })
      return
    }

    const currentIndex = indexAdjustment
    const nextMatchIndex = matchedIndices.find((idx) => idx > currentIndex)

    let targetIndex
    let searchPosition

    if (nextMatchIndex !== undefined) {
      targetIndex = nextMatchIndex
      searchPosition = matchedIndices.indexOf(nextMatchIndex)
    } else {
      targetIndex = matchedIndices[0]
      searchPosition = 0
    }

    const targetItem = adjustmentItems[targetIndex]

    if (showAll) {
      setTimeout(() => {
        scrollToItem(targetItem.orderitemId)
      }, 100)
    } else {
      setIndexAdjustment(targetIndex)
    }

    enqueueSnackbar(
      `Menampilkan hasil ${searchPosition + 1} dari ${matchedIndices.length}: ${targetItem.nameItem}`,
      { variant: 'info' },
    )
  }

  return (
    <>
      <Container ref={containerRef}>
        <div className="d-flex align-items-start gap-2 pt-3">
          <BreadCrumbs
            breadCrumbTitle="Beranda"
            breadCrumbParent2="Detail Pembelian"
            breadCrumbParent2Link={urlBackBreadcrumb}
            breadCrumbActive="Penyesuaian Pesanan"
          />
        </div>

        <Row className="g-3 mt-2">
          {/* LEFT COLUMN */}
          <Col xs={12} lg={4} xl={3}>
            <div
              style={{
                background: '#ffffff',
                padding: isMobile ? '12px' : '16px',
                borderRadius: '8px',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                position: isMobile ? 'relative' : 'sticky',
                top: isMobile ? 'auto' : '20px',
              }}
            >
              <div
                className="d-flex align-items-center justify-content-between gap-2"
                style={{
                  marginBottom: isMobile ? '12px' : '16px',
                  paddingBottom: '12px',
                  borderBottom: '1px solid #e5e7eb',
                }}
              >
                <div className="d-flex align-items-center gap-2">
                  <ArrowLeft
                    size={20}
                    style={{ cursor: 'pointer', color: '#006386' }}
                    onClick={() => navigate(urlNavigate)}
                  />
                  <h5
                    className="m-0"
                    style={{
                      fontSize: isMobile ? '16px' : '18px',
                      fontWeight: 700,
                      color: '#101828',
                    }}
                  >
                    Penyesuaian Pesanan
                  </h5>
                </div>

                {isMobile && (
                  <div
                    onClick={() => setIsLeftCardCollapsed(!isLeftCardCollapsed)}
                    style={{ cursor: 'pointer' }}
                  >
                    {isLeftCardCollapsed ? (
                      <ChevronDown size={20} color="#6b7280" />
                    ) : (
                      <ChevronUp size={20} color="#6b7280" />
                    )}
                  </div>
                )}
              </div>

              <Collapse isOpen={!isMobile || !isLeftCardCollapsed}>
                <div
                  style={{
                    padding: isMobile ? '6px 8px' : '8px 12px',
                    background: '#fef2f2',
                    border: '1px solid #fecaca',
                    borderRadius: '6px',
                    marginBottom: isMobile ? '8px' : '12px',
                  }}
                >
                  <p
                    className="mb-0"
                    style={{
                      fontSize: isMobile ? '11px' : '12px',
                      color: '#dc2626',
                      lineHeight: '1.4',
                    }}
                  >
                    Pembayaran tidak akan diteruskan ke penjual sebelum
                    penyesuaian selesai.
                  </p>
                </div>

                <div style={{ marginBottom: '16px' }}>
                  <P className="mb-1">Penjual</P>
                  <div
                    className="d-flex align-items-center gap-2"
                    style={{
                      padding: '10px',
                      background: '#f9fafb',
                      borderRadius: '6px',
                      border: '1px solid #e5e7eb',
                    }}
                  >
                    <ProfilePic
                      imgSrc={imageUser}
                      altText={sellerName}
                      name={sellerName}
                      avatarSeed={ownerPhoneNumber}
                      width={36}
                      height={36}
                    />
                    <div>
                      <p
                        className="mb-0"
                        style={{
                          fontSize: '13px',
                          fontWeight: 600,
                          color: '#111827',
                        }}
                      >
                        {sellerName ?? '-'}
                      </p>
                    </div>
                  </div>
                </div>

                {adjustmentItems?.length > 1 &&
                  (() => {
                    // ONLY UNIT KG
                    const kgData = unitSummaryArray?.find(
                      (item) => item?.unit?.toLowerCase() === 'kg',
                    )

                    if (!kgData) return null

                    // COUNT TOTAL ITEMS INVENTORY (ONLY KG UNIT)
                    const totalItemsInventory = kgData?.inventoryCount || 0

                    // USE totalAmount (ORIGINAL VALUE BEFORE ADJUSTMENT)
                    const totalKgAmount = kgData?.totalAmount || 0

                    return (
                      <div
                        className="mb-3 rounded"
                        style={{
                          padding: '12px',
                          backgroundColor: colors.primary[400],
                          color: 'white',
                          display: 'flex',
                          gap: 10,
                        }}
                      >
                        <P style={{ color: 'white', marginBottom: 0 }}>
                          Total: {newFormatThousandSeparator(totalKgAmount, 3)}{' '}
                          Unit+
                        </P>
                        <P style={{ color: 'white', marginBottom: 0 }}>
                          ({totalItemsInventory} Barang)
                        </P>
                      </div>
                    )
                  })()}
              </Collapse>
            </div>
          </Col>

          {/* RIGHT COLUMN */}
          <Col xs={12} lg={8} xl={9}>
            <div
              className="pb-2"
              style={{
                display: 'flex',
                flex: 1,
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: '10px',
                marginBottom: '10px',
                flexWrap: isMobile ? 'wrap' : 'nowrap',
              }}
            >
              <div style={{ flex: 1, minWidth: isMobile ? '100%' : '200px' }}>
                <PMBSearchInputGroup
                  maxWidth="100%"
                  value={searchQuery}
                  onChange={(e) => handleSearch(e.target.value)}
                  onClear={() => setSearchQuery('')}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handleSearchSubmit()
                    }
                  }}
                  placeholder="Cari nama barang, kode, lot, atau berat..."
                  testId="order-adjustment-search-input"
                />
              </div>
              <div
                className="d-flex align-items-center gap-2"
                style={{
                  width: isMobile ? '100%' : 'auto',
                  justifyContent: isMobile ? 'space-between' : 'flex-end',
                }}
              >
                <Button
                  color="primary"
                  outline
                  onClick={handleCheckAll}
                  disabled={!adjustmentItems || adjustmentItems.length === 0}
                  style={{
                    whiteSpace: 'nowrap',
                    fontSize: isMobile ? '12px' : '14px',
                    padding: isMobile ? '8px 12px' : '10px 16px',
                    flex: isMobile ? 1 : 'initial',
                  }}
                  data-testid="order-adjustment-check-all-button"
                >
                  <P size={isMobile ? 'small' : 'regular'}>
                    {isAllChecked
                      ? 'Batal Tandai Semua'
                      : 'Tandai Sudah Dicek Semua'}
                  </P>
                </Button>
                <Button
                  color="primary"
                  onClick={handleGoToUnchecked}
                  disabled={!adjustmentItems.some((item) => !item.isChecked)}
                  style={{
                    whiteSpace: 'nowrap',
                    fontSize: isMobile ? '12px' : '14px',
                    padding: isMobile ? '8px 12px' : '10px 16px',
                    flex: isMobile ? 1 : 'initial',
                  }}
                  data-testid="order-adjustment-unchecked-button"
                >
                  <P size={isMobile ? 'small' : 'regular'}>
                    {isMobile ? 'Item Belum Dicek' : 'Lanjut ke Item Belum Dicek'}
                  </P>
                </Button>
              </div>
            </div>

            {adjustmentItems?.length > 1 && (
              <div
                style={{
                  display: 'flex',
                  marginBottom: 10,
                }}
              >
                <div
                  style={{ cursor: 'pointer', width: '100%' }}
                  className="d-flex align-items-center justify-content-between"
                  onClick={() => {
                    setShowAll((prevState) => !prevState)
                    if (searchQuery) {
                      setTimeout(() => {
                        performSearch(searchQuery)
                      }, 500)
                    }
                  }}
                >
                  {!showAll ? (
                    <P>{`${indexAdjustment + 1} dari ${adjustmentItems?.length}`}</P>
                  ) : (
                    <div />
                  )}

                  <P color={'#006386'}>
                    {showAll ? 'Sembunyikan' : 'Lihat semua'}
                  </P>
                </div>
              </div>
            )}

            {/* LOOPING DATA ITEM ORDER */}
            {showAll ? (
              adjustmentItems?.map((item, index) => (
                <Card
                  key={item.orderitemId}
                  data-item-id={item.orderitemId}
                  data-testid={`order-adjustment-row-${item.orderitemId}`}
                  ref={(el) => {
                    if (el) {
                      itemRefs.current[item.orderitemId] = el
                    }
                  }}
                  className="border-0 shadow-sm rounded"
                  style={{
                    padding: 0,
                    marginBottom:
                      isMobile && index === adjustmentItems?.length - 1
                        ? isMobile && showAll
                          ? '20px'
                          : '100px'
                        : isMobile
                          ? '8px'
                          : '16px',
                    transition: 'all 0.3s ease',
                    scrollMarginTop: '100px',
                    ...(searchQuery &&
                      item?.nameItem
                        ?.toLowerCase()
                        .includes(searchQuery.toLowerCase()) && {
                      border: '2px solid #006386',
                      backgroundColor: '#f0f9ff',
                    }),
                  }}
                >
                  <CardBody style={{ padding: 0 }}>
                    <div
                      style={{
                        padding: isMobile ? '8px 10px' : '16px',
                        borderBottom: '1px solid #f0f0f0',
                        background: item.isChecked ? '#f0fdf4' : '#ffffff',
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-start mb-2">
                        <div
                          className="flex-grow-1"
                          style={{ paddingRight: '12px' }}
                        >
                          <h6
                            className="fw-bold mb-1"
                            style={{
                              fontSize: isMobile ? '15px' : '17px',
                              color: '#101828',
                              lineHeight: '1.4',
                            }}
                          >
                            {item.nameItem}
                          </h6>
                          <div className="d-flex align-items-center gap-2 flex-wrap">
                            <span
                              style={{
                                fontSize: isMobile ? '13px' : '14px',
                                color: '#667085',
                                fontWeight: 500,
                              }}
                            >
                              {newFormatThousandSeparator(item.amount ?? 0, 0)}{' '}
                              {item.unit}
                            </span>
                            <span style={{ color: '#d0d5dd' }}>•</span>
                            <span
                              style={{
                                fontSize: isMobile ? '13px' : '14px',
                                color: '#006386',
                                fontWeight: 600,
                              }}
                            >
                              Rp{newFormatThousandSeparator(item.price ?? 0, 0)}
                            </span>
                          </div>
                        </div>
                        <div className="d-flex flex-column align-items-end gap-2">
                          <div
                            className="d-flex align-items-center gap-1"
                            style={{ cursor: 'pointer' }}
                            onClick={() =>
                              handleFieldChange(
                                index,
                                'isChecked',
                                !item.isChecked,
                              )
                            }
                          >
                            <Input
                              type="checkbox"
                              id={`isChecked-showAll-${index}`}
                              checked={item.isChecked}
                              onChange={(e) => {
                                e.stopPropagation()
                                handleFieldChange(
                                  index,
                                  'isChecked',
                                  e.target.checked,
                                )
                              }}
                              style={{
                                cursor: 'pointer',
                                width: '16px',
                                height: '16px',
                              }}
                            />
                            <Label
                              htmlFor={`isChecked-showAll-${index}`}
                              className="mb-0"
                              style={{
                                cursor: 'pointer',
                                fontSize: isMobile ? '11px' : '12px',
                                fontWeight: 500,
                                color: item.isChecked ? '#047857' : '#6b7280',
                              }}
                            >
                              Tandai sudah dicek
                            </Label>
                          </div>

                          <h6
                            className="mb-0"
                            style={{
                              fontSize: isMobile ? '14px' : '17px',
                              fontWeight: 700,
                              color: '#006386',
                            }}
                          >
                            Rp
                            {newFormatThousandSeparator(
                              item.totalPrice ?? 0,
                              0,
                            )}
                          </h6>
                        </div>
                      </div>

                      <div
                        style={{
                          marginTop: isMobile ? '8px' : '10px',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'flex-end',
                        }}
                      >
                        <p
                          className="mb-0"
                          style={{
                            fontSize: isMobile ? '11px' : '12px',
                            color: '#6b7280',
                            fontWeight: 500,
                          }}
                        >
                          Kode Inventori:{' '}
                          <span style={{ color: '#111827', fontWeight: 600 }}>
                            {item.ownerCode}
                          </span>{' '}
                          <span style={{ color: '#d0d5dd' }}>•</span> Lot ID:{' '}
                          <span style={{ color: '#111827', fontWeight: 600 }}>
                            {item.lotCode}
                          </span>{' '}
                          <span style={{ color: '#d0d5dd' }}>•</span> Bundle:{' '}
                          <span style={{ color: '#111827', fontWeight: 600 }}>
                            {item.bundle ?? '-'}
                          </span>
                        </p>
                        <div
                          style={{ cursor: 'pointer' }}
                          onClick={(e) => {
                            e.stopPropagation()
                            setCollapsedItems((prev) => ({
                              ...prev,
                              [item.orderitemId]: !prev[item.orderitemId],
                            }))
                          }}
                        >
                          {collapsedItems[item.orderitemId] ? (
                            <ChevronUp size={20} color="#6b7280" />
                          ) : (
                            <ChevronDown size={20} color="#6b7280" />
                          )}
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: collapsedItems[item.orderitemId]
                          ? 'block'
                          : 'none',
                        padding: isMobile ? '8px 10px' : '16px',
                        background: '#ffffff',
                        borderTop: '1px solid #f0f0f0',
                      }}
                    >
                      <FormGroup>
                        <P
                          size="regular"
                          className="fw-semibold mb-2 gap-1 d-flex align-items-center"
                        >
                          Jumlah yang diterima
                          {item.newAmount < 1 && (
                            <span className="text-xs text-danger">
                              (Minimal 1)
                            </span>
                          )}
                        </P>
                        <PMBInputNumber
                          disabled={
                            item.isChecked || adjustFufilmentData?.length
                          }
                          onFocus={(e) => e.target.select()}
                          id={`jumlah-${index}`}
                          name={`jumlah-${index}`}
                          value={formatInputNumber(item.newAmount)}
                          onChange={(e) =>
                            handleAmountChange(index, e.target.value, 'amount')
                          }
                          placeholder="Masukkan jumlah"
                          prefix={item.unit}
                          isLastPrefix
                          min={1}
                        />
                      </FormGroup>

                      <Row className="mt-3">
                        <Col xs={6}>
                          <FormGroup>
                            <P size="regular" className="fw-semibold mb-2">
                              Harga per satuan
                            </P>
                            <PMBInputNumber
                              onFocus={(e) => e.target.select()}
                              disabled={
                                item.isChecked || Number(item?.newAmount) === 0
                              }
                              value={formatInputNumber(item.newSinglePrice)}
                              onChange={(e) =>
                                handleAmountChange(
                                  index,
                                  e.target.value,
                                  'price',
                                )
                              }
                              name={`harga-${index}`}
                              placeholder="Masukkan harga satuan"
                              prefix="Rp"
                              isFirstPrefix
                            />
                          </FormGroup>
                        </Col>
                        <Col xs={6}>
                          <FormGroup>
                            <P size="regular" className="fw-semibold mb-2">
                              Total harga
                            </P>
                            <PMBInputNumber
                              value={formatInputNumber(
                                item.newAmount * item.newSinglePrice,
                              )}
                              onChange={(e) =>
                                handleAmountChange(
                                  index,
                                  e.target.value,
                                  'price',
                                )
                              }
                              id={`total-${index}`}
                              prefix="Rp"
                              isFirstPrefix
                              disabled
                            />
                          </FormGroup>
                        </Col>
                      </Row>

                      <hr />

                      <Row className="mt-3">
                        <Col xs={12} md={6}>
                          <FormGroup>
                            <P size="regular" className="fw-semibold mb-2">
                              Tipe penyesuaian
                            </P>
                            <PMBSelect
                              value={editTypeOptions.find(
                                (opt) => opt.value === item.editType,
                              )}
                              onChange={(selected) =>
                                handleFieldChange(
                                  index,
                                  'editType',
                                  selected?.value || '',
                                )
                              }
                              options={editTypeOptions}
                              placeholder="Pilih tipe penyesuaian"
                              isDisabled={item.isChecked}
                            />
                          </FormGroup>
                        </Col>
                        <Col xs={12} md={6}>
                          <FormGroup>
                            <P size="regular" className="fw-semibold mb-2">
                              Penyebab
                            </P>
                            <PMBSelect
                              value={causeOfChangeOptions.find(
                                (opt) => opt.value === item.causeOfChange,
                              )}
                              onChange={(selected) =>
                                handleFieldChange(
                                  index,
                                  'causeOfChange',
                                  selected?.value || '',
                                )
                              }
                              options={causeOfChangeOptions}
                              placeholder="Pilih penyebab"
                              isDisabled={item.isChecked}
                              menuPortalTarget={
                                typeof window !== 'undefined'
                                  ? document.body
                                  : null
                              }
                            />
                          </FormGroup>
                        </Col>
                      </Row>

                      <FormGroup>
                        <P size="regular" className="fw-semibold mb-2">
                          Catatan
                        </P>
                        <Input
                          type="textarea"
                          style={{ minHeight: '100px' }}
                          id={`reason-${index}`}
                          name={`reason-${index}`}
                          value={item.reason}
                          onChange={(e) =>
                            handleFieldChange(index, 'reason', e.target.value)
                          }
                          placeholder="Masukkan alasan atau catatan"
                          disabled={item.isChecked}
                          styles={{
                            control: (provided) => ({
                              ...provided,
                              borderColor: '#d1d5db',
                              boxShadow: 'none',
                              '&:hover': {
                                borderColor: '#d1d5db',
                              },
                              borderRadius: '8px',
                              padding: '2px',
                              minWidth: '100%',
                              maxWidth: '100%',
                            }),
                          }}
                        />
                      </FormGroup>
                    </div>
                  </CardBody>
                </Card>
              ))
            ) : (
              <>
                <Card
                  key={adjustmentItems[indexAdjustment]?.orderitemId}
                  className="border-0 shadow-sm rounded"
                  data-testid={`order-adjustment-row-${adjustmentItems[indexAdjustment]?.orderitemId}`}
                  style={{
                    padding: isMobile ? '12px' : '16px',
                    marginBottom: isMobile ? '12px' : '20px',
                  }}
                >
                  <CardBody style={{ padding: 0 }}>
                    <div
                      style={{
                        padding: isMobile ? '12px' : '16px',
                        borderBottom: '1px solid #f0f0f0',
                        background: adjustmentItems[indexAdjustment]?.isChecked
                          ? '#f0fdf4'
                          : '#ffffff',
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-start mb-2">
                        <div
                          className="flex-grow-1"
                          style={{ paddingRight: '12px' }}
                        >
                          <h6
                            className="fw-bold mb-1"
                            style={{
                              fontSize: isMobile ? '15px' : '17px',
                              color: '#101828',
                              lineHeight: '1.4',
                            }}
                          >
                            {adjustmentItems[indexAdjustment]?.nameItem}
                          </h6>
                          <div className="d-flex align-items-center gap-2 flex-wrap">
                            <span
                              style={{
                                fontSize: isMobile ? '13px' : '14px',
                                color: '#667085',
                                fontWeight: 500,
                              }}
                            >
                              {newFormatThousandSeparator(
                                adjustmentItems[indexAdjustment]?.amount ?? 0,
                                0,
                              )}{' '}
                              {adjustmentItems[indexAdjustment]?.unit}
                            </span>
                            <span style={{ color: '#d0d5dd' }}>•</span>
                            <span
                              style={{
                                fontSize: isMobile ? '13px' : '14px',
                                color: '#006386',
                                fontWeight: 600,
                              }}
                            >
                              Rp
                              {newFormatThousandSeparator(
                                adjustmentItems[indexAdjustment]?.price ?? 0,
                                0,
                              )}
                            </span>
                          </div>
                        </div>
                        <div className="d-flex flex-column align-items-end gap-2">
                          <div
                            className="d-flex align-items-center gap-1"
                            style={{ cursor: 'pointer' }}
                            onClick={() =>
                              handleFieldChange(
                                indexAdjustment,
                                'isChecked',
                                !adjustmentItems[indexAdjustment]?.isChecked,
                              )
                            }
                          >
                            <Input
                              type="checkbox"
                              id={`isChecked-single-${indexAdjustment}`}
                              checked={
                                adjustmentItems[indexAdjustment]?.isChecked
                              }
                              onChange={(e) => {
                                e.stopPropagation()
                                handleFieldChange(
                                  indexAdjustment,
                                  'isChecked',
                                  e.target.checked,
                                )
                              }}
                              style={{
                                cursor: 'pointer',
                                width: '16px',
                                height: '16px',
                              }}
                            />
                            <Label
                              htmlFor={`isChecked-single-${indexAdjustment}`}
                              className="mb-0"
                              style={{
                                cursor: 'pointer',
                                fontSize: isMobile ? '11px' : '12px',
                                fontWeight: 500,
                                color: adjustmentItems[indexAdjustment]
                                  ?.isChecked
                                  ? '#047857'
                                  : '#6b7280',
                              }}
                            >
                              Tandai sudah dicek
                            </Label>
                          </div>

                          <h6
                            className="mb-0"
                            style={{
                              fontSize: isMobile ? '14px' : '17px',
                              fontWeight: 700,
                              color: '#006386',
                            }}
                          >
                            Rp
                            {newFormatThousandSeparator(
                              adjustmentItems[indexAdjustment]?.totalPrice ?? 0,
                              0,
                            )}
                          </h6>
                        </div>
                      </div>

                      <div
                        style={{
                          marginTop: isMobile ? '8px' : '10px',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'flex-end',
                        }}
                      >
                        <p
                          className="mb-0"
                          style={{
                            fontSize: isMobile ? '11px' : '12px',
                            color: '#6b7280',
                            fontWeight: 500,
                          }}
                        >
                          Kode Inventori:{' '}
                          <span style={{ color: '#111827', fontWeight: 600 }}>
                            {adjustmentItems[indexAdjustment]?.ownerCode}
                          </span>{' '}
                          <span style={{ color: '#d0d5dd' }}>•</span> Lot ID:{' '}
                          <span style={{ color: '#111827', fontWeight: 600 }}>
                            {adjustmentItems[indexAdjustment]?.lotCode}
                          </span>{' '}
                          <span style={{ color: '#d0d5dd' }}>•</span> Bundle:{' '}
                          <span style={{ color: '#111827', fontWeight: 600 }}>
                            {adjustmentItems[indexAdjustment]?.bundle ?? '-'}
                          </span>
                        </p>
                        <div
                          style={{ cursor: 'pointer' }}
                          onClick={(e) => {
                            e.stopPropagation()
                            setCollapsedItems((prev) => ({
                              ...prev,
                              [adjustmentItems[indexAdjustment]?.orderitemId]:
                                !prev[
                                adjustmentItems[indexAdjustment]?.orderitemId
                                ],
                            }))
                          }}
                        >
                          {collapsedItems[
                            adjustmentItems[indexAdjustment]?.orderitemId
                          ] ? (
                            <ChevronUp size={20} color="#6b7280" />
                          ) : (
                            <ChevronDown size={20} color="#6b7280" />
                          )}
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: collapsedItems[
                          adjustmentItems[indexAdjustment]?.orderitemId
                        ]
                          ? 'block'
                          : 'none',
                        padding: isMobile ? '12px' : '16px',
                        background: '#ffffff',
                        borderTop: '1px solid #f0f0f0',
                      }}
                    >
                      <FormGroup>
                        <P
                          size="regular"
                          className="fw-semibold mb-2 gap-1 d-flex align-items-center"
                        >
                          Jumlah yang diterima
                          {adjustmentItems[indexAdjustment]?.newAmount < 1 && (
                            <span className="text-xs text-danger">
                              (Minimal 1)
                            </span>
                          )}
                        </P>
                        <PMBInputNumber
                          disabled={
                            adjustmentItems[indexAdjustment]?.isChecked ||
                            adjustFufilmentData?.length
                          }
                          onFocus={(e) => e.target.select()}
                          id={`jumlah-${indexAdjustment}`}
                          name={`jumlah-${indexAdjustment}`}
                          value={formatInputNumber(
                            adjustmentItems[indexAdjustment]?.newAmount,
                          )}
                          onChange={(e) =>
                            handleAmountChange(
                              indexAdjustment,
                              e.target.value,
                              'amount',
                            )
                          }
                          placeholder="Masukkan jumlah"
                          prefix={adjustmentItems[indexAdjustment]?.unit}
                          isLastPrefix
                          min={1}
                        />
                      </FormGroup>

                      <Row className="mt-3">
                        <Col xs={6}>
                          <FormGroup>
                            <P size="regular" className="fw-semibold mb-2">
                              Harga per satuan
                            </P>
                            <PMBInputNumber
                              onFocus={(e) => e.target.select()}
                              disabled={
                                adjustmentItems[indexAdjustment]?.isChecked ||
                                Number(
                                  adjustmentItems[indexAdjustment]?.newAmount,
                                ) === 0
                              }
                              value={formatInputNumber(
                                adjustmentItems[indexAdjustment]
                                  ?.newSinglePrice,
                              )}
                              onChange={(e) =>
                                handleAmountChange(
                                  indexAdjustment,
                                  e.target.value,
                                  'price',
                                )
                              }
                              name={`harga-${indexAdjustment}`}
                              placeholder="Masukkan harga satuan"
                              prefix="Rp"
                              isFirstPrefix
                            />
                          </FormGroup>
                        </Col>
                        <Col xs={6}>
                          <FormGroup>
                            <P size="regular" className="fw-semibold mb-2">
                              Total harga
                            </P>
                            <PMBInputNumber
                              value={formatInputNumber(
                                adjustmentItems[indexAdjustment]?.newAmount *
                                adjustmentItems[indexAdjustment]
                                  ?.newSinglePrice,
                              )}
                              onChange={(e) =>
                                handleAmountChange(
                                  indexAdjustment,
                                  e.target.value,
                                  'price',
                                )
                              }
                              id={`total-${indexAdjustment}`}
                              prefix="Rp"
                              isFirstPrefix
                              disabled
                            />
                          </FormGroup>
                        </Col>
                      </Row>

                      <hr />

                      <Row className="mt-3">
                        <Col xs={12} md={6}>
                          <FormGroup>
                            <P size="regular" className="fw-semibold mb-2">
                              Tipe penyesuaian
                            </P>
                            <PMBSelect
                              value={editTypeOptions.find(
                                (opt) =>
                                  opt.value ===
                                  adjustmentItems[indexAdjustment]?.editType,
                              )}
                              onChange={(selected) =>
                                handleFieldChange(
                                  indexAdjustment,
                                  'editType',
                                  selected?.value || '',
                                )
                              }
                              options={editTypeOptions}
                              placeholder="Pilih tipe penyesuaian"
                              isDisabled={
                                adjustmentItems[indexAdjustment]?.isChecked
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col xs={12} md={6}>
                          <FormGroup>
                            <P size="regular" className="fw-semibold mb-2">
                              Penyebab
                            </P>
                            <PMBSelect
                              value={causeOfChangeOptions.find(
                                (opt) =>
                                  opt.value ===
                                  adjustmentItems[indexAdjustment]
                                    ?.causeOfChange,
                              )}
                              onChange={(selected) =>
                                handleFieldChange(
                                  indexAdjustment,
                                  'causeOfChange',
                                  selected?.value || '',
                                )
                              }
                              options={causeOfChangeOptions}
                              placeholder="Pilih penyebab"
                              isDisabled={
                                adjustmentItems[indexAdjustment]?.isChecked
                              }
                              menuPortalTarget={
                                typeof window !== 'undefined'
                                  ? document.body
                                  : null
                              }
                            />
                          </FormGroup>
                        </Col>
                      </Row>

                      <FormGroup>
                        <P size="regular" className="fw-semibold mb-2">
                          Catatan
                        </P>
                        <Input
                          type="textarea"
                          style={{ minHeight: '100px' }}
                          id={`reason-${indexAdjustment}`}
                          name={`reason-${indexAdjustment}`}
                          value={adjustmentItems[indexAdjustment]?.reason}
                          onChange={(e) =>
                            handleFieldChange(
                              indexAdjustment,
                              'reason',
                              e.target.value,
                            )
                          }
                          placeholder="Masukkan alasan atau catatan"
                          disabled={adjustmentItems[indexAdjustment]?.isChecked}
                        />
                      </FormGroup>
                    </div>
                  </CardBody>
                </Card>

                {adjustmentItems?.length > 1 && !showAll && (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginBottom: '2%',
                    }}
                  >
                    <Button
                      color="primary"
                      disabled={
                        searchQuery
                          ? getMatchingIndices(searchQuery).length === 0
                          : indexAdjustment < 1
                      }
                      onClick={handlePrevSameValueSearch}
                      data-testid="order-adjustment-prev-button"
                    >
                      <P>Sebelumnya</P>
                    </Button>

                    {searchQuery &&
                      getMatchingIndices(searchQuery).length > 0 && (
                        <div className="d-flex align-items-center px-2">
                          <P
                            size="small"
                            color="#667085"
                            className="text-center"
                          >
                            {getMatchingIndices(searchQuery).indexOf(
                              indexAdjustment,
                            ) + 1}{' '}
                            dari {getMatchingIndices(searchQuery).length} hasil
                          </P>
                        </div>
                      )}

                    <Button
                      color="primary"
                      disabled={
                        searchQuery
                          ? getMatchingIndices(searchQuery).length === 0
                          : indexAdjustment === adjustmentItems?.length - 1
                      }
                      onClick={handleNextSameValueSearch}
                      data-testid="order-adjustment-next-button"
                    >
                      <P>Selanjutnya</P>
                    </Button>
                  </div>
                )}
              </>
            )}

            <div>
              <P size="regular" color={'#101828'} className="font-semibold">
                Saya sebagai pembeli dengan sadar melakukan penyesuaian sesuai
                dengan perubahan di atas.
              </P>
            </div>

            <div style={{ minHeight: isMobile ? '200px' : '110px' }}></div>
          </Col>
        </Row>
      </Container>

      {/* FOOTER */}
      <PMBTotalFooter
        isAdjustBySeller={isAdjustBySeller}
        oldTotal={
          adjustmentItems.reduce(
            (acc, item) => acc + item.newAmount * item.newSinglePrice,
            0,
          ) !==
            data?.orderItems?.reduce(
              (acc, item) => acc + item.amount * item.price,
              0,
            )
            ? adjustmentItems.reduce(
              (acc, item) => acc + item.newAmount * item.newSinglePrice,
              0,
            )
            : null
        }
        total={data?.orderItems?.reduce(
          (acc, item) => acc + item.amount * item.price,
          0,
        )}
        isDisable={isDisabledProcess || isSubmitting}
        onSubmit={() => {
          checkCanAdjust(adjustmentItems)
        }}
        textBtn="Ajukan Penyesuaian"
        countChecked={countChecked}
        countTotal={data?.orderItems?.length}
        onSubmitDraft={() => saveDraftToAPI(true, adjustmentItems)}
        isDisabledProcess={isDisabledProcess}
        isLoadingSetDraft={isLoadingSetDraft}
        testId="order-adjustment-footer"
      />

      <Modal
        centered
        isOpen={showPreview}
        toggle={() => setShowPreview(false)}
        style={{ maxWidth: '600px' }}
        data-testid="order-adjustment-preview-modal"
      >
        <ModalHeader
          toggle={() => setShowPreview(false)}
          style={{
            position: 'sticky',
            top: 0,
            backgroundColor: '#fff',
            zIndex: 1,
            borderBottom: '1px solid #D0D5DD',
          }}
        >
          <P bold>Pratinjau penyesuaian</P>
        </ModalHeader>
        <ModalBody
          style={{
            overflowY: 'auto',
            minHeight: '300px',
            maxHeight: '60vh',
            padding: 0,
          }}
        >
          <div>
            <div>
              <div
                style={{ borderBottom: '1px solid #D0D5DD' }}
                className="p-3"
              >
                <P bold>Item pesanan yang disesuaikan</P>
                <div className="d-flex align-items-center gap-2">
                  <Info size={15} color="#d92d20" />
                  <P bold size="small" color={'#d92d20'}>
                    Harga dan jumlah bertanda merah menunjukkan nilai setelah
                    penyesuaian
                  </P>
                </div>
              </div>

              <div className="row g-8 m-1 my-3">
                {/* JUMLAH RETURN */}
                <div className="col-6">
                  <PMBBadge
                    key="return"
                    variant="danger"
                    title={calculateTotalByType(adjustmentItems, 'return')}
                    description="Return"
                    className="p-4"
                  />
                </div>

                {/* JUMLAH ADJUSTMENT */}
                <div className="col-6">
                  <PMBBadge
                    key="adjustment"
                    variant="blues"
                    title={calculateTotalByType(adjustmentItems, 'adjustment')}
                    description="Penyesuaian"
                    className="p-4"
                  />
                </div>
              </div>

              <div className="px-3">
                {adjustmentItems
                  ?.filter(
                    (el, i) =>
                      data?.orderItems?.[i]?.amount !== el?.newAmount ||
                      data?.orderItems?.[i]?.price !== el?.newSinglePrice,
                  )
                  ?.map((el, i) => {
                    return (
                      <div
                        className="mt-2 mb-2 bg-light p-2 rounded border border-gray-200"
                        key={i}
                      >
                        <div>
                          <P>{el?.nameItem}</P>
                          <div className="d-flex align-items-center justify-content-between">
                            <P
                              className={'text-primary'}
                            >{`${newFormatThousandSeparator(Number(data?.orderItems?.[i]?.amount ?? 0))} ${data?.orderItems?.[i]?.unit} x Rp${newFormatThousandSeparator(Number(data?.orderItems?.[i]?.price ?? 0))}`}</P>
                            <P
                              className={'text-primary'}
                            >{`Rp${newFormatThousandSeparator(Number(data?.orderItems?.[i]?.amount * data?.orderItems?.[i]?.price))}`}</P>
                          </div>

                          <>
                            <div className="d-flex justify-content-between">
                              <P className="text-sm" color={'#d92d20'}>
                                (
                                {newFormatThousandSeparator(
                                  Number(el?.newAmount ?? 0),
                                )}{' '}
                                <span className="text-capitalize">
                                  {el?.unit}
                                </span>{' '}
                                x Rp
                                {newFormatThousandSeparator(
                                  Number(el?.newSinglePrice ?? 0),
                                  0,
                                )}
                                )
                              </P>
                              <P size="regular" color={'#d92d20'}>
                                (Rp
                                {newFormatThousandSeparator(
                                  Number(
                                    el?.newAmount * el?.newSinglePrice ?? 0,
                                  ),
                                  0,
                                )}
                                )
                              </P>
                            </div>
                          </>
                        </div>
                        {el?.editType && (
                          <>
                            <div className="mt-2">
                              <Row>
                                <Col md="6">
                                  <P size="small" className="text-muted">
                                    Tipe Perubahan
                                  </P>
                                  <span className="font-semibold">
                                    {el?.editType?.toUpperCase() ===
                                    'ADJUSTMENT'
                                      ? 'Penyesuaian'
                                      : capitalizeEveryWord(el?.editType)}
                                  </span>
                                </Col>
                                <Col md="6" className="mt-2 mt-md-0">
                                  <P size="small" className="text-muted">
                                    Penyebab
                                  </P>
                                  <span className="font-semibold">
                                    {el?.causeOfChange}
                                  </span>
                                </Col>
                              </Row>

                              <Row className="mt-2">
                                <Col md="6">
                                  <P size="small" className="text-muted">
                                    Catatan
                                  </P>
                                  <span className="font-semibold">
                                    {el?.reason}
                                  </span>
                                </Col>
                              </Row>
                            </div>
                          </>
                        )}
                      </div>
                    )
                  })}
              </div>
            </div>
          </div>
        </ModalBody>
        <div
          className="gap-2"
          style={{
            position: 'sticky',
            bottom: 0,
            backgroundColor: '#fff',
            zIndex: 1,
          }}
        >
          <PMBTotalFooter
            isAdjustBySeller={isAdjustBySeller}
            oldTotal={
              adjustmentItems.reduce(
                (acc, item) => acc + item.newAmount * item.newSinglePrice,
                0,
              ) !==
                data?.orderItems?.reduce(
                  (acc, item) => acc + item.amount * item.price,
                  0,
                )
                ? adjustmentItems.reduce(
                  (acc, item) => acc + item.newAmount * item.newSinglePrice,
                  0,
                )
                : null
            }
            total={data?.orderItems?.reduce(
              (acc, item) => acc + item.amount * item.price,
              0,
            )}
            isDisable={isDisabledProcess || isSubmitting}
            customStyle={{ display: '', padding: '16px' }}
            onSubmit={handleSubmitAdjustment}
            textBtn="Ajukan Penyesuaian"
            testId="order-adjustment-submit-button"
          />
        </div>
      </Modal>
    </>
  )
}

export default OrderAdjustment
